import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

type PageViewParams = {
  path: string;
  title?: string;
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (!analytics) return;
  try {
    logEvent(analytics, eventName, params);
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Analytics event failed:', err);
    }
  }
};

export const trackPageView = ({ path, title }: PageViewParams) => {
  trackEvent('page_view', {
    page_path: path,
    page_title: title || document.title,
  });
};

export const trackWebVital = (metric: {
  name: string;
  value: number;
  id: string;
}) => {
  trackEvent('web_vital', {
    name: metric.name,
    value: metric.value,
    id: metric.id,
  });
};
